export { default } from './ProductFAQScreen';
export * from './ProductFAQScreen';
